import { formatCombo } from '@/hooks/useHotkeys';
import { cn } from '@/lib/cn';

/** Keyboard hint. `<Kbd keys="alt+1" />` -> Alt+1. Also accepts children for free text. */
export function Kbd({
  keys,
  children,
  className,
  onColor = false,
}: {
  keys?: string;
  children?: React.ReactNode;
  className?: string;
  /** On a solid coloured button: translucent chip that inherits the button text colour. */
  onColor?: boolean;
}) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center rounded border px-1.5 py-0.5 font-mono text-[11px] leading-none',
        onColor
          ? 'border-current/40 bg-transparent text-inherit'
          : 'border-border bg-surface-2 text-fg-muted',
        className,
      )}
    >
      {children ?? (keys ? formatCombo(keys) : null)}
    </kbd>
  );
}
